import React from 'react'
import ReactDOM from "react-dom";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Modal, Button } from 'react-bootstrap'

import { closeAllModals } from './actions'
import { 
  changeTemplatePriority, 
  changeTemplateDescription,
  changeTemplateCulture, 
  changeTemplateOcrMode, 
  changeTemplateOcrLanguage, 
  changeTemplateOcrResolution,
  changeTemplateOcrImageFilters,
  changeTemplateOcrWhiteList,
  changeTemplateOcrBlackList    
} from '../template/actions'

import classNames from 'classnames'

class TemplateSettingsModal extends React.Component {
  render() {
    const culturesOptions = cultures.map(el => <option key={el[0]} value={el[0]}>{el[0]} - {el[1]}</option>)

    return (
      <Modal 
      
          // trying to fix issue with modal appearing behind some existing elements
          fade={false}
          style={{overlay: {zIndex: 999}, opacity: 1}}
          animation={false}      
          transition={false}
          // end of the fix      
                
      show={this.props.templateSettingsModalOpened} onHide={this.props.closeAllModals} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Template Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <div className="form-group row">
            <label className="col-sm-5 col-form-label">Template Description</label>
            <div className="col-sm-7">
              <textarea
                type="text"
                name="templateDescription"
                id="templateDescription"
                className="form-control"              
                cols="30" rows="2"
                placeHolder="enter short description of template here"
                value={this.props.description}
                onChange={e => this.props.changeTemplateDescription(e.target.value)}
              >
              </textarea>

            </div>
          </div>
                    
          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Template version</label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                placeholder="Template version"
                value={this.props.templateVersion}
                disabled={true}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Template priority</label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                placeholder="Template priority"
                value={this.props.templatePriority}
                onChange={e => this.props.changeTemplatePriority(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Culture</label>
            <div className="col-sm-7">
              <select
                name="templateCulture"
                id="templateCulture"
                className="form-control"
                value={this.props.culture}
                onChange={e => this.props.changeTemplateCulture(e.target.value)}
              >
                {culturesOptions}
              </select>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-5 col-form-label">OCR Mode</label>
            <div className="col-sm-7">
              <select
                name="templateOcrMode"
                id="templateOcrMode"
                className="form-control"
                value={this.props.ocrMode}
                onChange={e => this.props.changeTemplateOcrMode(e.target.value)}
              >
                <option value="auto">Auto</option>
                <option value="forced">Forced</option>
                <option value="repairFonts">Repair Fonts</option>
              </select>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-5 col-form-label">OCR Language</label>
            <div className="col-sm-7">
              <select
                name="templateOcrLanguage"
                id="templateOcrLanguage"
                className="form-control"
                value={this.props.ocrLanguage}
                onChange={e => this.props.changeTemplateOcrLanguage(e.target.value)}
              >

                <option value="eng">English</option>
                <option value="ara">Arabic</option>
                <option value="ces">Czech</option>
                <option value="chi_sim">Chinese Simplified</option>
                <option value="chi_tra">Chinese Traditional</option>
                <option value="dan">Danish</option>
                <option value="deu">German</option>
                <option value="ell">Greek</option>
                <option value="fin">Finnish</option>
                <option value="fra">French</option>
                <option value="heb">Hebrew</option>
                <option value="hin">Hindi</option>
                <option value="ind">Indonesian</option>
                <option value="ita">Italian</option>
                <option value="jpn">Japanese</option>
                <option value="kor">Korean</option>
                <option value="nld">Dutch</option>
                <option value="nor">Norwegian</option>
                <option value="pol">Polish</option>
                <option value="por">Portuguese </option>
                <option value="por">Portuguese</option>
                <option value="rus">Russian</option>
                <option value="spa">Spanish</option>
                <option value="swe">Swedish</option>
                <option value="tur">Turkish</option>
                <option value="ukr">Ukrainian</option>
                <option value="vie">Vietnamese</option>

              </select>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-5 col-form-label">OCR Resolution</label>
            <div className="col-sm-7">
              <select
                name="templateOcrResolution"
                id="templateOcrResolution"
                className="form-control"
                value={this.props.ocrResolution}
                onChange={e => this.props.changeTemplateOcrResolution(e.target.value)}
              >
                <option value="300">300</option>
                <option value="200">200</option>
                <option value="150">150</option>
                <option value="600">600</option>
              </select>
            </div>
          </div>          


          <div className="form-group row">
            <label className="col-sm-5 col-form-label">OCR Image Filters</label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                placeholder="OCR Image Filters"
                value={this.props.ocrImageFilters}
                onChange={e => this.props.changeTemplateOcrImageFilters(e.target.value)}
              />
            </div>
          </div>


          <div className="form-group row">
            <label className="col-sm-5 col-form-label">OCR Allow List</label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                placeholder="OCR Allow List"
                value={this.props.ocrWhiteList}
                onChange={e => this.props.changeTemplateOcrWhiteList(e.target.value)}
              />
            </div>
          </div>


          <div className="form-group row">
            <label className="col-sm-5 col-form-label">OCR Deny List</label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                placeholder="OCR Deny List"
                value={this.props.ocrBlackList}
                onChange={e => this.props.changeTemplateOcrBlackList(e.target.value)}
              />
            </div>
          </div>                       
                    
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.closeAllModals}>
            Save and Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


function mapStateToProps(state) {
  return {
    templateSettingsModalOpened: state.modals.templateSettingsModalOpened,
    templatePriority: state.template.templatePriority,
    description: state.template.description,
    templateVersion: state.template.templateVersion,
    ocrMode: state.template.options && state.template.options.ocrMode,
    culture: state.template.culture,
    ocrLanguage: state.template.options && state.template.options.ocrLanguage,
    ocrResolution: state.template.options && state.template.options.ocrResolution,
    ocrImageFilters: state.template.options && state.template.options.ocrImageFilters,
    ocrWhiteList: state.template.options && state.template.options.ocrWhiteList,
    ocrBlackList: state.template.options && state.template.options.ocrBlackList,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
  {
    closeAllModals,
    changeTemplatePriority,
    changeTemplateCulture,
    changeTemplateDescription,
    changeTemplateOcrMode,
    changeTemplateOcrLanguage,
    changeTemplateOcrResolution,
    changeTemplateOcrImageFilters,
    changeTemplateOcrWhiteList,
    changeTemplateOcrBlackList
  }, 
  dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateSettingsModal)

// full languages list was taken from http://www.lingoes.net/en/translator/langcode.htm
const cultures = [
  
  [ "af-ZA", "Afrikaans (South Africa)"],
  [ "ar-AE", "Arabic (U.A.E.)"],
  [ "ar-BH", "Arabic (Bahrain)"],
  [ "ar-DZ", "Arabic (Algeria)"],
  [ "ar-EG", "Arabic (Egypt)"],
  [ "ar-IQ", "Arabic (Iraq)"],
  [ "ar-JO", "Arabic (Jordan)"],
  [ "ar-KW", "Arabic (Kuwait)"],
  [ "ar-LB", "Arabic (Lebanon)"],
  [ "ar-LY", "Arabic (Libya)"],
  [ "ar-MA", "Arabic (Morocco)"],
  [ "ar-OM", "Arabic (Oman)"],
  [ "ar-QA", "Arabic (Qatar)"],
  [ "ar-SA", "Arabic (Saudi Arabia)"],
  [ "ar-SY", "Arabic (Syria)"],
  [ "ar-TN", "Arabic (Tunisia)"],
  [ "ar-YE", "Arabic (Yemen)"],
  [ "az-AZ", "Azeri (Latin) (Azerbaijan)"],
  [ "az-AZ", "Azeri (Cyrillic) (Azerbaijan)"],
  [ "be-BY", "Belarusian (Belarus)"],
  [ "bg-BG", "Bulgarian (Bulgaria)"],
  [ "bs-BA", "Bosnian (Bosnia and Herzegovina)"],
  [ "ca-ES", "Catalan (Spain)"],
  [ "cs-CZ", "Czech (Czech Republic)"],
  [ "cy-GB", "Welsh (United Kingdom)"],
  [ "da-DK", "Danish (Denmark)"],
  [ "de-AT", "German (Austria)"],
  [ "de-CH", "German (Switzerland)"],
  [ "de-DE", "German (Germany)"],
  [ "de-LI", "German (Liechtenstein)"],
  [ "de-LU", "German (Luxembourg)"],
  [ "dv-MV", "Divehi (Maldives)"],
  [ "el-GR", "Greek (Greece)"],
  [ "en-AU", "English (Australia)"],
  [ "en-BZ", "English (Belize)"],
  [ "en-CA", "English (Canada)"],
  [ "en-CB", "English (Caribbean)"],
  [ "en-GB", "English (United Kingdom)"],
  [ "en-IE", "English (Ireland)"],
  [ "en-JM", "English (Jamaica)"],
  [ "en-NZ", "English (New Zealand)"],
  [ "en-PH", "English (Republic of the Philippines)"],
  [ "en-TT", "English (Trinidad and Tobago)"],
  [ "en-US", "English (United States)"],
  [ "en-ZA", "English (South Africa)"],
  [ "en-ZW", "English (Zimbabwe)"],
  [ "es-AR", "Spanish (Argentina)"],
  [ "es-BO", "Spanish (Bolivia)"],
  [ "es-CL", "Spanish (Chile)"],
  [ "es-CO", "Spanish (Colombia)"],
  [ "es-CR", "Spanish (Costa Rica)"],
  [ "es-DO", "Spanish (Dominican Republic)"],
  [ "es-EC", "Spanish (Ecuador)"],
  [ "es-ES", "Spanish (Castilian)"],
  [ "es-ES", "Spanish (Spain)"],
  [ "es-GT", "Spanish (Guatemala)"],
  [ "es-HN", "Spanish (Honduras)"],
  [ "es-MX", "Spanish (Mexico)"],
  [ "es-NI", "Spanish (Nicaragua)"],
  [ "es-PA", "Spanish (Panama)"],
  [ "es-PE", "Spanish (Peru)"],
  [ "es-PR", "Spanish (Puerto Rico)"],
  [ "es-PY", "Spanish (Paraguay)"],
  [ "es-SV", "Spanish (El Salvador)"],
  [ "es-UY", "Spanish (Uruguay)"],
  [ "es-VE", "Spanish (Venezuela)"],
  [ "et-EE", "Estonian (Estonia)"],
  [ "eu-ES", "Basque (Spain)"],
  [ "fa-IR", "Farsi (Iran)"],
  [ "fi-FI", "Finnish (Finland)"],
  [ "fo-FO", "Faroese (Faroe Islands)"],
  [ "fr-BE", "French (Belgium)"],
  [ "fr-CA", "French (Canada)"],
  [ "fr-CH", "French (Switzerland)"],
  [ "fr-FR", "French (France)"],
  [ "fr-LU", "French (Luxembourg)"],
  [ "fr-MC", "French (Principality of Monaco)"],
  [ "gl-ES", "Galician (Spain)"],
  [ "gu-IN", "Gujarati (India)"],
  [ "he-IL", "Hebrew (Israel)"],
  [ "hi-IN", "Hindi (India)"],
  [ "hr-BA", "Croatian (Bosnia and Herzegovina)"],
  [ "hr-HR", "Croatian (Croatia)"],
  [ "hu-HU", "Hungarian (Hungary)"],
  [ "hy-AM", "Armenian (Armenia)"],
  [ "id-ID", "Indonesian (Indonesia)"],
  [ "is-IS", "Icelandic (Iceland)"],
  [ "it-CH", "Italian (Switzerland)"],
  [ "it-IT", "Italian (Italy)"],
  [ "ja-JP", "Japanese (Japan)"],
  [ "ka-GE", "Georgian (Georgia)"],
  [ "kk-KZ", "Kazakh (Kazakhstan)"],
  [ "kn-IN", "Kannada (India)"],
  [ "ko-KR", "Korean (Korea)"],
  [ "kok-IN", "Konkani (India)"],
  [ "ky-KG", "Kyrgyz (Kyrgyzstan)"],
  [ "lt-LT", "Lithuanian (Lithuania)"],
  [ "lv-LV", "Latvian (Latvia)"],
  [ "mi-NZ", "Maori (New Zealand)"],
  [ "mk-MK", "FYRO Macedonian (Former Yugoslav Republic of Macedonia)"],
  [ "mn-MN", "Mongolian (Mongolia)"],
  [ "mr-IN", "Marathi (India)"],
  [ "ms-BN", "Malay (Brunei Darussalam)"],
  [ "ms-MY", "Malay (Malaysia)"],
  [ "mt-MT", "Maltese (Malta)"],
  [ "nb-NO", "Norwegian (Bokm?l) (Norway)"],
  [ "nl-BE", "Dutch (Belgium)"],
  [ "nl-NL", "Dutch (Netherlands)"],
  [ "nn-NO", "Norwegian (Nynorsk) (Norway)"],
  [ "ns-ZA", "Northern Sotho (South Africa)"],
  [ "pa-IN", "Punjabi (India)"],
  [ "pl-PL", "Polish (Poland)"],
  [ "ps-AR", "Pashto (Afghanistan)"],
  [ "pt-BR", "Portuguese (Brazil)"],
  [ "pt-PT", "Portuguese (Portugal)"],
  [ "qu-BO", "Quechua (Bolivia)"],
  [ "qu-EC", "Quechua (Ecuador)"],
  [ "qu-PE", "Quechua (Peru)"],
  [ "ro-RO", "Romanian (Romania)"],
  [ "ru-RU", "Russian (Russia)"],
  [ "sa-IN", "Sanskrit (India)"],
  [ "se-FI", "Sami (Northern) (Finland)"],
  [ "se-FI", "Sami (Skolt) (Finland)"],
  [ "se-FI", "Sami (Inari) (Finland)"],
  [ "se-NO", "Sami (Northern) (Norway)"],
  [ "se-NO", "Sami (Lule) (Norway)"],
  [ "se-NO", "Sami (Southern) (Norway)"],
  [ "se-SE", "Sami (Northern) (Sweden)"],
  [ "se-SE", "Sami (Lule) (Sweden)"],
  [ "se-SE", "Sami (Southern) (Sweden)"],
  [ "sk-SK", "Slovak (Slovakia)"],
  [ "sl-SI", "Slovenian (Slovenia)"],
  [ "sq-AL", "Albanian (Albania)"],
  [ "sr-BA", "Serbian (Latin) (Bosnia and Herzegovina)"],
  [ "sr-BA", "Serbian (Cyrillic) (Bosnia and Herzegovina)"],
  [ "sr-SP", "Serbian (Latin) (Serbia and Montenegro)"],
  [ "sr-SP", "Serbian (Cyrillic) (Serbia and Montenegro)"],
  [ "sv-FI", "Swedish (Finland)"],
  [ "sv-SE", "Swedish (Sweden)"],
  [ "sw-KE", "Swahili (Kenya)"],
  [ "syr-SY", "Syriac (Syria)"],
  [ "ta-IN", "Tamil (India)"],
  [ "te-IN", "Telugu (India)"],
  [ "th-TH", "Thai (Thailand)"],
  [ "tl-PH", "Tagalog (Philippines)"],
  [ "tn-ZA", "Tswana (South Africa)"],
  [ "tr-TR", "Turkish (Turkey)"],
  [ "tt-RU", "Tatar (Russia)"],
  [ "uk-UA", "Ukrainian (Ukraine)"],
  [ "ur-PK", "Urdu (Islamic Republic of Pakistan)"],
  [ "uz-UZ", "Uzbek (Latin) (Uzbekistan)"],
  [ "uz-UZ", "Uzbek (Cyrillic) (Uzbekistan)"],
  [ "vi-VN", "Vietnamese (Viet Nam)"],
  [ "xh-ZA", "Xhosa (South Africa)"],
  [ "zh-CN", "Chinese (S)"],
  [ "zh-HK", "Chinese (Hong Kong)"],
  [ "zh-MO", "Chinese (Macau)"],
  [ "zh-SG", "Chinese (Singapore)"],
  [ "zh-TW", "Chinese (T)"],
  [ "zu-ZA", "Zulu (South Africa)"]

]
